import styled from 'styled-components';

export const ContentDate = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  gap: 10px;
`;
